/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamDenikSsl extends GContentBase<SeznamDenikSslObj> {
        private seznamObj: SeznamDenikSslObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamDenikSslObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamDenikSsl",
                contentCaption: "jres:33000100", //RC 33000455 : Vlastnosti
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{sslden}"
                },
                gridSettings: {
                    columnOrder: "sslden,zkratka,nazev,poznamka,dat_zmena,zmenu_prov_txt,rok_akt,typ_den_txt,priz_den_txt,priz_den_ts_txt,format_cj,format_cj_pis,format_cj_ext,format_spz"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamDenikSslObj extends GAdmSeznamBase {
        nazev: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            this.detailCnt = $.content().navigate(["Gordic.Adm.WebControls.DetailDenikSsl", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailDenikSsl",
                newRecord: isNew,
                sslden: isNew == true ? null : data.sslden
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenRokyPodacihoDeniku: {
                    caption: "jres:33000612",
                    icon: "fa-link",
                    run: () => {
                        this.openRokyPodacihoDeniku();
                    }
                },
                actOpenDenikSslSpisovyUzel: {
                    caption: "jres:33000614",
                    icon: "fa-link",
                    run: () => {
                        this.openDenikSslSpisovyUzel();
                    }
                },
                actOpenHromadnaOperaceAdmDenikSslSpisovyUzel: {
                    caption: "jres:33000617", //RC 33000617 : P�i�adit hromadn� spisov� uzly
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceAdmDenikSslSpisovyUzel();
                    }
                },
                actOpenSeznamOrganizacniJednotkaDenikSsl: {
                    caption: "jres:33000619", //RC 33000619 : St�ediska nav�zan� na den�k
                    icon: "fa-link",
                    run: () => {
                        this.openDenikSslOrganizacniStredisko();
                    }
                },
                actOpenHromadnaOperaceOrganizacniJednotkaDenikSsl: {
                    caption: "jres:33000621", //RC 33000621 : P�i�adit hromadn� st�ediska spis. uz.
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceOrganizacniJednotkaDenikSsl();
                    }
                },
                actOpenSeznamAdmFunkcniMistoDenikSsl: {
                    caption: "jres:33000622", //RC 33000619 : St�ediska nav�zan� na den�k
                    icon: "fa-link",
                    run: () => {
                        this.openAdmFunkcniMistoDenikSsl();
                    }
                },
                actOpenHromadnaOperaceAdmFunkcniMistoDenikSsl: {
                    caption: "jres:33000623",
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceAdmFunkcniMistoDenikSsl();
                    }
                },
                actOpenSeznamAdmDenikSslStrediskoSpisovychUzlu: {
                    caption: "jres:33000624".format(this.nazev), //RC 33000619 : St�ediska nav�zan� na den�k
                    icon: "fa-link",
                    run: () => {
                        this.openSeznamAdmDenikSslStrediskoSpisovychUzlu();
                    }
                },
                actOpenHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu: {
                    caption: "jres:33000627".format(this.nazev.charAt(0).toLowerCase() + this.nazev.slice(1)), //RC 33000627 : Hromadn� v�zat {0} na den�k
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu();
                    }
                },
                actOpenSeznamAdmDenikSslStupenUtajeni: {
                    caption: "jres:33000629",
                    icon: "fa-link",
                    run: () => {
                        this.openAdmDenikSslStupenUtajeni()
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenRokyPodacihoDeniku },
                        { action: this.cnt.actions.actOpenSeznamAdmDenikSslStupenUtajeni },
                        { action: this.cnt.actions.actOpenDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenSeznamAdmDenikSslStrediskoSpisovychUzlu },
                        { action: this.cnt.actions.actOpenSeznamAdmFunkcniMistoDenikSsl },
                        { action: this.cnt.actions.actOpenSeznamOrganizacniJednotkaDenikSsl },
                    ]
                },
                {
                    favorite: true, type: "static", caption: "jres:33000628", icon: "fa-link", children: [ //RC 33000628 : Hromadn� operace
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu },
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmFunkcniMistoDenikSsl },
                        { action: this.cnt.actions.actOpenHromadnaOperaceOrganizacniJednotkaDenikSsl }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenRokyPodacihoDeniku },
                        { action: this.cnt.actions.actOpenSeznamAdmDenikSslStupenUtajeni },
                        { action: this.cnt.actions.actOpenDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenSeznamAdmDenikSslStrediskoSpisovychUzlu },
                        { action: this.cnt.actions.actOpenSeznamAdmFunkcniMistoDenikSsl },
                        { action: this.cnt.actions.actOpenSeznamOrganizacniJednotkaDenikSsl },
                    ]
                }, 
                {
                    favorite: true, type: "static", caption: "jres:33000628", icon: "fa-link", children: [ //RC 33000628 : Hromadn� operace
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu },
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmFunkcniMistoDenikSsl },
                        { action: this.cnt.actions.actOpenHromadnaOperaceOrganizacniJednotkaDenikSsl }
                    ]
                }
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.DenikSsl.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.setPlatnostColumn(this.view);
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            if (objArr.count == 1) {
                var activerow = this.grid.ggrid("activeRow");
                this.cnt.actions.actOpenSeznamAdmDenikSslStupenUtajeni?.update({ enabled: activerow.priz_stu == 1 });
            } else {
                this.cnt.actions.actOpenSeznamAdmDenikSslStupenUtajeni?.update({ enabled: false })
            }
            this.cnt.actions.actOpenRokyPodacihoDeniku?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenDenikSslSpisovyUzel?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslSpisovyUzel?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenSeznamOrganizacniJednotkaDenikSsl?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmFunkcniMistoDenikSsl?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmDenikSslStrediskoSpisovychUzlu?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenHromadnaOperaceOrganizacniJednotkaDenikSsl?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenHromadnaOperaceAdmFunkcniMistoDenikSsl?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.sslsden),
                nazev: data["nazev"]
            }
        }

        private openRokyPodacihoDeniku() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmRokDenikuSsl", { sslden: activeRow.sslden })
        }

        private openDenikSslSpisovyUzel() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslSpisovyUzel", { sslden: activeRow.sslden })
        }

        private openDenikSslOrganizacniStredisko() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamOrganizacniJednotkaDenikSsl", { sslden: activeRow.sslden })
        }

        private openAdmFunkcniMistoDenikSsl() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMistoDenikSsl", { sslden: activeRow.sslden })
        }

        private openSeznamAdmDenikSslStrediskoSpisovychUzlu() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslStrediskoSpisovychUzlu", { sslden: activeRow.sslden })
        }

        private openAdmDenikSslStupenUtajeni() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslStupenUtajeni", { sslden: activeRow.sslden })
        }

        private openHromadnaOperaceAdmDenikSslSpisovyUzel() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        sslden: item["sslden"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmDenikSslSpisovyUzel", { openFromSpisUzel: false }], { ID: "HromadnaOperaceAdmDenikSslSpisovyUzel", data: data }, "", 700, 500)
        }

        private openHromadnaOperaceOrganizacniJednotkaDenikSsl() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GOrganizacniJednotkaDenikSslReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        sslden: item["sslden"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceOrganizacniJednotkaDenikSsl"], { ID: "HromadnaOperaceOrganizacniJednotkaDenikSsl", data: data }, "", 700, 500)
        }

        private openHromadnaOperaceAdmFunkcniMistoDenikSsl() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmFunkcniMistoDenikSslReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        sslden: item["sslden"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmFunkcniMistoDenikSsl"], { ID: "HromadnaOperaceAdmFunkcniMistoDenikSsl", data: data }, "", 700, 500)
        }

        private openHromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmDenikSslStrediskoSpisovychUzluReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        sslden: item["sslden"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu"], { ID: "HromadnaOperaceAdmDenikSslStrediskoSpisovychUzlu", data: data }, "", 700, 500)
        }
    }
}